import { O as Oe } from './index.esm-CXYreJ4v.js';

/**
 * FancyboxGallery Web Component
 *
 * Usage:
 * 1. Add the <fancybox-gallery> element to wrap your gallery
 * 2. Add data-fancybox="gallery" attribute to any clickable elements (e.g. <a> tags)
 * 3. Set the href attribute to the full size media URL
 *
 * Example:
 * <fancybox-gallery>
 *   <a data-fancybox="gallery" href="/path/to/full-image.jpg">
 *     <img src="/path/to/thumbnail.jpg">
 *   </a>
 * </fancybox-gallery>
 */
class FancyboxGallery extends HTMLElement {
  connectedCallback() {
    this.fancyboxInstance = Oe.bind('[data-fancybox]', {
      slug: 'media',
      startIndex: 1,
      Carousel: {
        Navigation: false,
      },
      dragToClose: false,
      Thumbs: false,
      Toolbar: {
        items: {
          prevCustom: {
            tpl: `<button class="f-button"><span class="icon flex justify-center [&>svg]:h-full [&>svg]:w-full size-5"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5516 18.1215L9.06212 17.8772L3.42969 12.2448L3.42969 11.7553L9.06212 6.12387L9.5516 5.87864L11.5105 5.87864L11.7557 6.12387L11.7557 6.36811L7.34747 10.7754L7.34747 11.0206L20.325 11.0206L20.5702 11.2658L20.5702 12.7353L20.325 12.9795L7.34747 12.9795L7.34747 13.2247L11.7557 17.632L11.7557 17.8772L11.5105 18.1215L9.5516 18.1215Z" fill="currentColor" stroke="none"/></svg></span></button>`,
            click: () => {
              Oe.getInstance().prev();
            },
          },
          nextCustom: {
            tpl: `<button class="f-button"><span class="icon flex justify-center [&>svg]:h-full [&>svg]:w-full size-5"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.4483 5.87866L14.9378 6.1229L20.5702 11.7553L20.5702 12.2448L14.9378 17.8762L14.4483 18.1215L12.4894 18.1215L12.2442 17.8762L12.2442 17.632L16.6524 13.2248L16.6524 12.9795L3.67488 12.9795L3.42964 12.7343L3.42964 11.2649L3.67488 11.0206L16.6524 11.0206L16.6524 10.7754L12.2442 6.36814L12.2442 6.1229L12.4894 5.87866L14.4483 5.87866Z" fill="currentColor" stroke="none"></path>
</svg></span></button>`,
            click: () => {
              Oe.getInstance().next();
            },
          },
          closeCustom: {
            tpl: `<button class="f-button close"><span class="icon flex justify-center [&>svg]:h-full [&>svg]:w-full size-5"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6227 5.21558L18.7518 5.36694L18.6403 6.76648L18.6248 6.7818L18.6299 6.78778L13.4144 12.0033L18.6403 17.2335L18.7518 18.6331L18.6227 18.7844L17.6432 18.8624L17.3262 18.7428L17.3257 18.7433L12 13.4176L6.67432 18.7433L6.67383 18.7428L6.35687 18.8624L5.37732 18.7844L5.24829 18.6331L5.35974 17.2335L10.5857 12.0033L5.37018 6.78778L5.37531 6.7818L5.3598 6.76648L5.24829 5.36694L5.37732 5.21558L6.35693 5.13757L6.67407 5.25732L12 10.5877L17.326 5.25732L17.6431 5.13757L18.6227 5.21558Z" fill="currentColor" stroke="none"/></svg></span></button>`,
            click: () => {
              Oe.getInstance().close();
            },
          },
        },
        display: {
          left: [],
          middle: ['prevCustom', 'nextCustom', 'iterateZoom'],
          right: ['closeCustom'],
        },
        absolute: true,
      },
    });
  }
}

customElements.define('fancybox-gallery', FancyboxGallery);
